<script setup>
import { cn } from "../../../lib/utils";

const props = defineProps({
  class: { type: null, required: false },
});
</script>

<template>
  <div
    data-slot="card-footer"
    :class="
      cn(
        'bg-muted/50 rounded-b-xl px-4 py-3.5 group-data-[size=sm]/card:px-3 group-data-[size=sm]/card:py-3 flex items-center',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
